<div class="container-custom h-100 d-flex justify-content-center">
  <div id="my-card" class="jumbotron my-auto">
      <h4 id="admin-login-title-text" class="d-flex justify-content-center">Corporate Access</h4>
      <p id="admin-login-welcome-text" class="d-flex justify-content-center mb-4">Welcome to Stock Exchange of Thailand Registration</p>
      <div class="d-flex justify-content-center">
          <button id="admin-login-office-365-button" class="btn btn-lean" (click)=login()><img src="/assets/images/ms-logo.png" width="36px" height="36px" alt="">LOGIN to SET MS Office 365</button>
      </div>
  </div>
</div>
